import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { refreshApp } from 'apps/root/actions/root';

const INIT_PAYMENT_POST = `${config.apiBasePath}/slotsub/init-payment`;
const FINISH_REGISTRATION_POST = `${config.apiBasePath}/slotsub/finish-registration`;

export const OR_STATUS_PENDING = 'PENDING';
export const OR_STATUS_ERROR = 'ERROR';
export const OR_STATUS_SUCCESS = 'SUCCESS';

export const OR_CLOSE_PAYMENT_MODAL = 'OR_CLOSE_PAYMENT_MODAL';
export const OR_SET_PAYMENT_STATUS = 'OR_SET_PAYMENT_STATUS';
export const OR_REQUEST_INIT_PAYMENT_DATA = 'OR_REQUEST_INIT_PAYMENT_DATA';
export const OR_RECEIVE_INIT_PAYMENT_DATA = 'OR_RECEIVE_INIT_PAYMENT_DATA';
export const OR_RECEIVE_INIT_PAYMENT_DATA_ERROR = 'OR_RECEIVE_INIT_PAYMENT_DATA_ERROR';
export const OR_REQUEST_FINISH_REGISTRATION = 'OR_REQUEST_FINISH_REGISTRATION';
export const OR_RECEIVE_FINISH_REGISTRATION = 'OR_RECEIVE_FINISH_REGISTRATION';
export const OR_RECEIVE_FINISH_REGISTRATION_ERROR = 'OR_RECEIVE_FINISH_REGISTRATION_ERROR';

export function closePaymentModal() {
  return {
    type: OR_CLOSE_PAYMENT_MODAL,
  };
}

export function setPaymentStatus(status) {
  return {
    type: OR_SET_PAYMENT_STATUS,
    status,
  };
}

export function requestLinkUsagePayment() {
  return {
    type: OR_REQUEST_INIT_PAYMENT_DATA,
  };
}

export function receiveLinkUsagePayment(data) {
  return {
    type: OR_RECEIVE_INIT_PAYMENT_DATA,
    data,
  };
}

export function receiveLinkUsagePaymentError({ error }) {
  return {
    type: OR_RECEIVE_INIT_PAYMENT_DATA_ERROR,
    error,
  };
}

export function initPayment(paymentData) {
  return (dispatch, getState, { network }) => {
    dispatch(requestLinkUsagePayment());
    return network.post(INIT_PAYMENT_POST, {
      body: JSON.stringify(paymentData),
    })
      .then((data) => {
        dispatch(receiveLinkUsagePayment(data));
      })
      .catch(err => {
        dispatch(receiveLinkUsagePaymentError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function requestFinishRegistration() {
  return {
    type: OR_REQUEST_FINISH_REGISTRATION,
  };
}

export function receiveFinishRegistration(data) {
  return {
    type: OR_RECEIVE_FINISH_REGISTRATION,
    data,
  };
}

export function receiveFinishRegistrationError({ error }) {
  return {
    type: OR_RECEIVE_FINISH_REGISTRATION_ERROR,
    error,
  };
}

export function finishRegistration() {
  return (dispatch, getState, { network }) => {
    dispatch(requestFinishRegistration());
    return network.post(FINISH_REGISTRATION_POST)
      .then((data) => {
        dispatch(receiveFinishRegistration(data));
        dispatch(refreshApp());
      })
      .catch(err => {
        dispatch(receiveFinishRegistrationError(err.data || UNKNOWN_ERROR));
      });
  };
}
